/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioOperationResponseSchema = z.object({
  attemptCount: z.int(),
  error: z.string().nullish(),
  finishedAt: z.iso.datetime().nullish(),
  id: z.int(),
  queuedAt: z.iso.datetime(),
  result: z.optional(
    z.union([
      z.array(z.any()),
      z.boolean(),
      z.string(),
      z.number(),
      z.object({}).catchall(z.any()),
      z.null(),
    ]),
  ),
  status: z.enum(['QUEUED', 'RUNNING', 'SUCCEEDED', 'FAILED', 'EXPIRED']),
  type: z.enum(['SYNC', 'RESET', 'ACTIVATE']),
});
